type FormValue =
  | string
  | number
  | boolean
  | null
  | undefined
  | File
  | Record<string, unknown>
  | Array<string | number | boolean | File | null | undefined | Record<string, unknown>>;

export type FormPayload = Record<string, FormValue>;

const appendValue = (formData: FormData, key: string, value: FormValue) => {
  if (value === undefined || value === null || value === '') {
    return;
  }

  if (Array.isArray(value)) {
    const containsComplexValue = value.some(
      (item) => item !== null && item !== undefined && typeof item === 'object' && !(item instanceof File),
    );

    if (containsComplexValue) {
      formData.append(key, JSON.stringify(value));
      return;
    }

    value.forEach((item) => {
      if (item === undefined || item === null || item === '') {
        return;
      }

      formData.append(`${key}[]`, item instanceof File ? item : String(item));
    });
    return;
  }

  if (!(value instanceof File) && typeof value === 'object') {
    Object.entries(value).forEach(([nestedKey, nestedValue]) => {
      if (nestedValue === undefined || nestedValue === null || nestedValue === '') {
        return;
      }

      if (Array.isArray(nestedValue) || (typeof nestedValue === 'object' && nestedValue !== null)) {
        formData.append(`${key}[${nestedKey}]`, JSON.stringify(nestedValue));
        return;
      }

      formData.append(`${key}[${nestedKey}]`, String(nestedValue));
    });
    return;
  }

  formData.append(key, value instanceof File ? value : String(value));
};

export const toFormData = (payload: FormPayload) => {
  const formData = new FormData();

  Object.entries(payload).forEach(([key, value]) => appendValue(formData, key, value));

  return formData;
};
